<template>
  <div>
    <Top />
    <div class="maindiv zindex-wrap">
      <Banner />
      <div class="sys htmldiv tright twhite ofhidden">
        <a href="/lms/web" target="_blank" class="zbtn zbtn-ggreen fr">
          <div class="fs24">我要学习</div>
          <div class="fmt tupper">Learning</div>
        </a>
        <router-link to="/cedu/sign" class="zbtnc zbtn-gcoffee fr">
          <div class="fs24">我要报名</div>
          <div class="fmt tupper">Sign Up</div>
        </router-link>
      </div>

      <div class="nsdiv htmldiv mt25 ofhidden">
        <div class="ldiv wd840 ht380 fl dborder dborder-green vtop br2">
          <div class="ml5 mt15 mb20 pl10">
            <router-link v-if="isNotice" to="/cedu/notice/index" class="fr tc9 fs16 mr20 mt5 hc-green">
              更多&gt;&gt;
            </router-link>
            <router-link v-else to="/cedu/policies/index" class="fr tc9 fs16 mr20 mt5 hc-green">
              更多&gt;&gt;
            </router-link>
            <span class="fs26 tcenter cpointer" :class="{fbold: isNotice}" @mouseover="isNotice=true">通知公告</span>
            <span class="fs24 tcenter ml15 mr15">|</span>
            <span class="fs26 tcenter cpointer" :class="{fbold: !isNotice}" @mouseover="isNotice=false">政策法规</span>
          </div>
          <div class="cont">
            <div v-show="isNotice" class="pl5 pr5 trans3">
               <div v-for="item in notice" :key="item.id" @click="goDetail(`/cedu/notice/detail?id=${item.id}`)" class="cpointer fs16 snt snt-green cpointer ofhidden prelative">
                 <span class="fs tc9 fr pabsolute mr15">{{item.release_time}}</span>
                 {{item.title}}
               </div>
            </div>
            <div v-show="!isNotice" class="pl5 pr5 trans3">
              <div v-for="item in policiesRegulations" :key="item.id"  @click="goDetail(`/cedu/policies/detail?id=${item.id}`)" class="fs16 snt snt-green cpointer ofhidden prelative">
                 <span class="fs tc9 fr pabsolute mr15">{{item.release_time}}</span>
                {{item.title}}
              </div>
            </div>
          </div>
        </div>
        <div class="rdiv wd405 ht380 fr dborder dborder-green vtop br2">
          <div class="ml5 mt15 mb20 pl10">
            <router-link to="/cedu/form/index" class="fr tc9 fs16 mr20 mt5 hc-green">
              更多&gt;&gt;
            </router-link>
            <span class="fs26 tcenter cpointer fbold">表格下载</span>
          </div>
          <div class="cont pt5">
           <div v-for="item in formDownload" :key="item.id" @click="goDetail(`/cedu/form/detail?id=${item.id}`)" class="fs16 sdd cpointer ofhidden prelative">
              <div class="nm ofhidden mb5">{{item.title}}</div>
              <div class="fs12 tc9">
                <span class="mr30">{{item.views_count}}人下载</span>
                <span class="mr30">发布时间：{{item.release_time}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!--div class="dsdiv mt35">
        <div class="htmldiv">
          <div class="zst">
            <router-link to="/cedu/professional/index" class="more fr tc9 mt5 mr5 gborder br2">更多+</router-link>
            <span class="tt blue prelative dinline-block prelative pb5 fs24 fbold">专业介绍</span>
            <span class="tc16 fs18"> / </span>
            <span class="tupper tc16 fs16 farial">Profesasional presentation</span>
          </div>
          <div class="cont pt5 fs0 pt20">
            <EduImgItem :controller="'cedu'" v-for="(item,index) in proIntroduction" v-if="index<4" :key="index" :index="index" :item="item"/>
          </div>
        </div>
      </div-->
      <div class="adiv htmldiv mt25">
        <a href="https://www.zikao365.com/" class="ofhidden dinline-block fs24 mr25" target="_blank">
          <img class="trans" src="../../../assets/images/index_10_01.jpg" alt="">
        </a>
        <a href="http://www.zjnep.com/" class="ofhidden dinline-block fs24" target="_blank">
          <img class="trans" src="../../../assets/images/index_10_02.jpg" alt="">
        </a>
        <a href="https://www.zjzs.net/moban/index/index.html" class="ofhidden fr fs24" target="_blank">
          <img class="trans" src="../../../assets/images/ksy.png" alt="">
        </a>
      </div>

      <div class="cediv htmldiv mt35 dborder-green">
        <div>
          <router-link to="/cedu/school/index"  class="fr tc9 fs16 mr10 mt5 hc-green">更多&gt;&gt;</router-link>
          <div class="fs26 fbold ml5 mt15">主考院校</div>
        </div>
        <div class="cont">
          <SchoolItem v-for="(item,index) in schools" v-if="index<4" :key="index" :item="item" :index="index"/>
        </div>
      </div>
      <!-- <div class="newsdiv htmldiv pb20">
        <div class="sdiv dinline-block vtop">
          <div class="zst">
            <router-link to="/cedu/data/index" class="more fr tc9 mt5 mr5 gborder br2">更多+</router-link>
            <span class="tt blue prelative dinline-block prelative pb5 fs24 fbold">自考资料</span>
            <span class="tc16 fs18"> / </span>
            <span class="tupper tc16 fs16 farial">Self-study information</span>
          </div>
          <div class="cont pt15">
            <ZkItem v-for="(item,index) in selfStudy" v-if="index<5" :key="index" :item="item" :index="index"/>
          </div>
        </div>
        <div class="notice sdiv dinline-block vtop">
          <div class="zst">
            <router-link to="/cedu/notice/index" class="more fr tc9 mt5 mr5 gborder br2">更多+</router-link>
            <span class="tt blue prelative dinline-block prelative pb5 fs24 fbold">通知公告</span>
            <span class="tc16 fs18"> / </span>
            <span class="tupper tc16 fs16 farial">Notice</span>
          </div>
          <div class="cont pt20">
            <NoticeItem v-for="(item,index) in notice" v-if="index<5" :key="index" :item="item" :index="index"/>
          </div>
        </div>
      </div> -->
    </div>
    <Bottom />
  </div>
</template>

<script>
  import Top from '../top.vue'
  import Banner from '../banner.vue'
  import Bottom from '../bottom.vue'
  import EduImgItem from '../../index/edu-img-item'
  import SchoolItem from '../school-item'
  import ZkItem from '../zk-item'
  import NoticeItem from '../notice-item'
  export default {
    name: "index",
    data () {
      return {
        'proIntroduction': [],
        'schools': [],
        'selfStudy': [],
        'notice': [],
        'isNotice': true,
        'policiesRegulations':[],
        'formDownload':[],
      }
    },
    methods:{
      goDetail (path){
        let routeData = this.$router.resolve({
          path
        })
        console.log(path)
        window.open(routeData.href, '_blank')
      }
    },
    components:{
      Top,
      Banner,
      Bottom,
      EduImgItem,
      SchoolItem,
      ZkItem,
      NoticeItem,
    },
    created() {
      this.$request.get('self-study/index', {},response => {
        if(response.status == 200){
          this.proIntroduction = response.data.data.selfStudyMajorList;
          this.schools = response.data.data.schoolList;
          this.selfStudy = response.data.data.selfStudyMaterialList;
          this.notice = response.data.data.noticeList;
          this.policiesRegulations = response.data.data.policiesRegulations;
          this.formDownload = response.data.data.formDownload;
          console.log('------------')
          console.log(this.policiesRegulations)
        }
        console.log(response);
      },error => {
        console.log(error);
      })
    },
  }
</script>

<style scoped>
  .more{padding: 6px 12px;}
  .more:hover{color: #3a8c39;border-color: #3a8c39;}

  .sys{margin-top: -45px;}
  .sys .zbtn{padding: 10px 45px 0 85px;height: 72px;background: #7daf27 url(../../../assets/images/cn1.png) 10px -423px;text-align: left;}
  .sys .zbtnc{padding: 10px 45px 0 85px;height: 72px;background:#3a8c39 url(../../../assets/images/cn1.png) 10px -572px;text-align: left;}
  .sys .zbtn:hover{background-color: #3a8c39;}
  .sys .zbtnc:hover{background-color: #7daf27;}
  .zst .tt::before{content: '';position: absolute;z-index: -1;left: -8px;top: -2px;width: 22px;height: 22px;background: #9cc59c;border-radius: 50%;}
  .cediv .cont{padding: 20px 0 25px;}
  .cediv .zcollege{margin-right: 32px;}
  .newsdiv .notice{margin-left: 100px;width: 435px;}
  .dsdiv .sdiv:hover{margin-top: -5px;}
  .dsdiv .sdiv{margin: 0 9px;}
  .dsdiv .sdiv:nth-child(4n + 1){margin-left: 0;}
  .dsdiv .sdiv:nth-child(4n){margin-right: 0;}
  .dsdiv .sdiv:hover .nm{color: #3a8c39!important;}
  .dsdiv .sdiv:hover .cur{background: #3a8c39!important;}

  .adiv a{width: 405px;height: 145px;}
  .adiv a:hover{box-shadow: 0px 0px 10px #3a8c39;}
</style>



// WEBPACK FOOTER //
// src/components/cedu/index/index.vue